export default __webpack_public_path__ + "static/media/congratulations-complet.13053823.webp";